import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromCommon from './reducers/common.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CommonEffects } from './effects/common.effects';
import { CommonService } from '../common-store/services/common.service';
import { Destroy } from '../common-store/services/destroy.service';
import { SubscriptionService } from '../common-store/services/subscription.service';
import { CommonFacade } from './facades/common.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromCommon.commonFeatureKey, fromCommon.reducer),
    EffectsModule.forFeature([CommonEffects]),
  ],
  providers: [CommonService, Destroy, SubscriptionService, CommonFacade],
})
export class CommonStoreModule {}
